export function levelToActions(level) {
  // This will need to be updated again , once we introduce more permissions across site.
  switch (level) {
    // case "read":
    //   return ["view"];
    // case "write":
    //   return ["view", "edit"];
    case "admin":
      // return ["view", "edit", "delete", "admin"];
      return ["admin"];
    case "none":
    default:
      return [];
  }
}

export function actionsToLevel(actions) {
  const set = new Set(actions || []);
  if (set.has("admin")) return "admin";
  // Those will have to be re-enabled once permissions are more specific.
  // if (set.has("edit") || set.has("delete")) return "write";
  // if (set.has("view")) return "read";
  return "none";
}

export function grantsToLevelsObject(grants) {
  const obj = {};
  for (const g of grants || []) {
    if (!g?.resource) continue;
    obj[g.resource] = actionsToLevel(g.actions);
  }
  return obj;
}

export function levelsObjectToGrants(levelsObj) {
    if (!levelsObj) return {};
    return Object.entries(levelsObj || {})
    .map(([resource, level]) => {
        const actions = levelToActions(level);
        return actions.length ? { resource, actions } : null;
    })
    .filter(Boolean);
};

